var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-footer"},[_c('footer',{staticClass:"px-0 py-2"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-md-between"},[_c('div',[_vm._v(" Copyright 2024 - All Rights Reserved. ")]),_c('div',[_c('b',{staticClass:"text-primary"},[_vm._v("AllAccessPay")])])])])])])
}]

export { render, staticRenderFns }